<template>
  <q-page>
    <div class="q-pa-md">
      <div class="row q-col-gutter-md">
        <div class="col-12">
          <div class="row">
            <div class="col-9">
              <div class="row">
                <div class="page-title q-mr-sm">Outcomes</div>
              </div>
            </div>
            <div class="col-3">
              <q-input
                class="searchbar float-right"
                style="max-width: 70%"
                filled
                v-model="search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"></q-icon>
                </template>
              </q-input>
            </div>
          </div>
        </div>
        <div class="col-12">
          <q-card>
            <div class="row">
              <div class="col-12 mt-0 pt-0" style="height: calc(100vh - 195px)">
                <data-table
                  :filter="search"
                  flat
                  :data="outcomesList"
                  headerBgColor="#162c47"
                  headerTextColor="white"
                  :columns="columns"
                  @rowDoubleClick="onRowDoubleClick"
                >
                </data-table>
              </div>
            </div>
          </q-card>
        </div>
      </div>
    </div>
    <q-dialog v-model="outcomeDialog" full-width full-height persistent>
      <outcome-form
        :newOutcome="newOutcome"
        ref="outcomeDialog"
        @closeDialog="closeOutcomeDialog"
      ></outcome-form>
    </q-dialog>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import DataTable from "@/components/datatable/datatable.vue";
  import OutcomeForm from "@/components/outcomes/outcomeForm.vue";
  export default {
    beforeCreate() {
      this.$store.dispatch("outcomes/loadAll");
      this.$store.dispatch("sections/loadAll");
    },
    components: {
      DataTable,
      OutcomeForm,
    },
    computed: {
      ...mapGetters({
        outcomesList: "outcomes/list",
        outcomesListLoading: "outcomes/listLoading",
        sectionsList: "sections/list",
      }),
      columns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "outcomeName",
            label: "Outcome Name",
            align: "left",
            field: "name",
            sortable: true,
          },
          {
            name: "umbrella",
            label: "Umbrella",
            align: "left",
            field: "umbrella",
            sortable: true,
          },
          {
            name: "createdAt",
            label: "Created At",
            align: "left",
            field: "created_at",
            format: (val) => {
              return this.$options.filters.gridDateFormat(val);
            },
            sortable: true,
            style:
              "min-width:300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
    },
    watch: {
      $route: {
        handler(value) {
          if (value.params.hasOwnProperty("id")) {
            this.openSelectedOutcome(value.params.id);
          }
        },
        deep: true,
      },
    },
    data: () => ({
      newOutcome: false,
      outcomeDialog: false,
      submitLoading: false,
      search: "",
      generalRules: [(v) => !!v || "Name is Required"],
      formData: {},
    }),
    mounted() {
      if (this.$route.params.hasOwnProperty("id")) {
        this.openSelectedOutcome(this.$route.params.id);
      }
    },
    methods: {
      resetForm() {
        this.formData = {};
      },
      onRowDoubleClick(row) {
        this.$router.push("/outcomes/" + row.id);
      },
      closeOutcomeDialog() {
        this.outcomeDialog = false;
      },
      openSelectedOutcome(id) {
        this.newOutcome = false;
        this.$store.dispatch("outcomes/loadOutcomeByID", id);
        this.$store.dispatch("sources/loadAll");
        this.$store.dispatch("outcomes/loadAllOutcomesCategories");
        this.$store.dispatch("outcomes/sources/loadAllByOutcomesID", id);
        this.outcomeDialog = true;
        this.$nextTick(() => {
          this.$refs.outcomeDialog.initOutcomeFormData();
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .page-title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
  }
</style>
